import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { Button, Field, Icon, Input, useDesignSystemTheme } from "@xinghai/ui";
import { useTheme } from "../../app/theme";
import { formatInviteCodeInput, normalizeInviteCode } from "./inviteCode";

/**
 * ACCOUNTS.md §2 — the staff entry point when someone has the code but not
 * the link. Continues into the same accept form as `/invite/:token`.
 */
export function InviteCodePage() {
  const navigate = useNavigate();
  const { theme } = useTheme();
  useDesignSystemTheme(theme);

  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);

  const submit = () => {
    const token = normalizeInviteCode(code);
    if (!token) {
      setError("邀请码看起来不对。它长这样：XH-8F3K-22QD，也可以直接粘贴收到的链接。");
      return;
    }
    void navigate(`/invite/${encodeURIComponent(token)}`);
  };

  return (
    <main className="xz-login">
      <form
        className="xz-login__card gz-panel gz-panel--raised"
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
      >
        <h1 className="gz-type-heading">输入邀请码</h1>
        <p className="gz-muted">
          管理员发给你的邀请码，形如 XH-8F3K-22QD。如果拿到的是一条链接，也可以直接粘贴进来。
        </p>

        <Field label="邀请码" error={error ?? undefined}>
          <Input
            value={code}
            autoCapitalize="characters"
            autoCorrect="off"
            spellCheck={false}
            placeholder="XH-8F3K-22QD"
            onChange={(e) => {
              setCode(formatInviteCodeInput(e.target.value));
              setError(null);
            }}
          />
        </Field>

        <Button type="submit" variant="primary" size="lg" block>
          下一步
        </Button>
        <p className="gz-caption">
          <Icon id="ui-info" size={16} /> 你是学生？请用<Link to="/register">班级邀请码注册</Link>。
        </p>
      </form>
    </main>
  );
}
